/**
 * This is a generic EventEmitter which can be used to listen and trigger
 * callbacks on specific actions.
 *
 * Things like the `googleAnalytics` can attach on to analytics events.
 */
import EventEmitter from "./EventEmitter";

const appEvents = new EventEmitter({
  debug: process.env.NODE_ENV === "development"
});

export default appEvents;
